// extracted by mini-css-extract-plugin
module.exports = {"SiteFooter":"SiteFooter_SiteFooter__mTFao"};